import render from './render';
export default async function eventTemplate({ event, isEmail, uid, canRespond, }) {
    const response = (uid && event.responses && event.responses[uid]) ? event.responses[uid] : 'no';
    const active = {
        no: '',
        maybe: '',
        yes: '',
        [response]: 'active',
    };
    const units = ['day', 'week', 'month', 'year'];
    const repeatsEveryUnit = event.repeats && units.find(x => { var _a; return (_a = event.repeats) === null || _a === void 0 ? void 0 : _a.every[x]; });
    const repeatsEndDateFinite = Number.isFinite(event.repeats && event.repeats.endDate);
    const reminders = event.reminders.sort((a, b) => a - b);
    return await render('partials/calendar/event/post', {
        event,
        isEmail,
        uid,
        response,
        active,
        repeatsEveryUnit,
        repeatsEndDateFinite,
        reminders,
        canRespond,
    });
}
